import { useQuery } from '@tanstack/react-query';
import { DematerializedItemTypes } from '../../../../../libs/constants/product';
import useJwt from '../../utils/useJwt';
import useLocaleQueryFilter from '../../utils/useLocaleQueryFilter';
import { AttributeValue } from './useAttributes';
import { OrderCardType } from './useOrders';
import { ImageType } from './useProducts';

export type OrderItemType = {
  id: number;
  defaultProductImage?: ImageType;
  localizedProductImage?: ImageType;
  defaultVariantImage?: ImageType;
  localizedVariantImage?: ImageType;
  label: string;
  status: string;
  quantity: number;
  totalMilesAmount: number;
  attributes: AttributeValue[];
  dematerializedType: DematerializedItemTypes;
  externalReferences: { providerId: number; externalReference: string }[];
};

type OrderLightType = {
  orderItems: OrderItemType[];
} & Omit<OrderCardType, 'image'>;

export default function useOrderLight(orderId: number) {
  const jwt = useJwt();
  const filter = useLocaleQueryFilter({ orderId, jwt });
  return useQuery<OrderLightType, Error>(['orders/oneLight', filter], {
    enabled: !!jwt && !!orderId,
  });
}
